import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 18rem;
`;

const Text = styled.span`
  display: block;
  margin-bottom: 1em;
  font-size: 1.2rem;
`;

const Title = styled.h3`
  padding-top: 1rem;
`;

const Contact = () => {
  return (
    <Container>
      <Title>Legal Notice</Title>
      <Text>
        <b>TóMSTUND UG (haftungsbeschränkt)</b>
      </Text>
      <Text>
        <b>MANAGING DIRECTOR </b> <br />
        Astrid B. Jantz
      </Text>
      <Text>
        <b>ADRESSE </b> <br />
        Chausseestraße 15 <br />
        15345 Rüdersdorf bei Berlin
      </Text>
      <Text>
        <b>HANDELSREGISTER </b> <br />
        Amtsgericht Frankfurt/Oder HRB 16138 FF
      </Text>
      <Text>USt-IdNr: DE309516390 </Text>
      <Text>
        <b>MAIL </b> <br />
        contact@tomstund.com <br />
        contact@sampell.com
      </Text>
      <Text>
        <b> WEB </b> <br />
        www.sampell.com
      </Text>
    </Container>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Pages/Contact/Contact.js